import {saveAs} from 'file-saver';

export class PrintDesignController {

    constructor($log, $scope, UserSessionService, $analytics) {
        'ngInject';

        this.$log = $log;
        this.$scope = $scope;
        this.userSessionService = UserSessionService;
        this.$analytics = $analytics;

        UserSessionService.downloadDesign().then((response) => {
            var byteCharacters = atob(response);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {type: 'application/pdf'});

            saveAs(blob, 'design.pdf');

            this.$scope.$dismiss();
        });

        this.$analytics.pageTrack('/print-design');
        this.$analytics.eventTrack('download', {  category: 'Print design' });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/print-design/print-design.controller.js